export function screenSize(sizes) {
  return { type: 'SCREEN_SIZE', sizes };
}
